/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuMultiSelectSearch_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterCreator_searchBrowse$ref: FragmentReference;
export type SbSharedRefineMenuFilterCreator_searchBrowse = {|
  +$fragmentRefs: SbSharedRefineMenuMultiSelectSearch_searchBrowse$ref,
  +$refType: SbSharedRefineMenuFilterCreator_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterCreator_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '9676f0089fa9d7ea0e051da09960ef3f';
module.exports = node;
